import { getIsInstructor } from 'store/selectors'

export const getIsInstructorOrAdmin = (course, userAq) => {
  if (!course || !userAq) return
  const isInstructor = getIsInstructor(course)
  const isAdmin = userAq?.is_admin
  return isInstructor || isAdmin
}
